export const woundProgress = {
  new: "New",
  better: "Improving",
  stable: "Stable",
  stalled: "Stalled",
  worse: "Deteriorating",
  healed: "Resolved",
  monitoring: "Monitoring",
  unknown: "Status Unknown"
};
